import { useParams } from 'react-router-dom';
import './SettingsPage.scss';
import { Icon, Card } from '@design-system/index';
import { ShopsSettingsLine } from '@assets/images/icons';
import { SettingsTabs } from './SettingsTabs';
import { Tabs } from '@components/Tabs/Tabs';

export default function SettingsPage() {
    const { tab } = useParams();
    const tabIndex = SettingsTabs().findIndex(t => t.path === tab);

    return (
        <div className="details-settings-container">
            <Card headerType='full' showBack backTo="/products-management" headerTitle="Paramètres boutique" headerIcon={<Icon icon={<ShopsSettingsLine />} size={20} color="green" />}>
                <Tabs orientation="horizontal" tabs={SettingsTabs} defaultActiveTab={tabIndex === -1 ? 0 : tabIndex}/>
            </Card>
        </div>
    );
};
